import { useTranslate } from "@tolgee/react";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useUserData } from "../../auth/useUserData.js";
import { PageNotFound } from "../../commons/PageNotFound.js";
import { PageTopbarItem } from "../../commons/layout/Page.js";
import { InvoiceIcon } from "../../features/invoices/InvoiceIcon.js";
import { PurchaseOrderIcon } from "../../features/purchase-orders/PurchaseOrderIcon.js";
import { QuoteIcon } from "../../features/quotes/QuoteIcon.js";
import { Invoices } from "./Invoices.js";
import { PurchaseOrders } from "./PurchaseOrders.js";
import { Quotes } from "./Quotes.js";
import { RestrictedByCapability } from "../../auth/RestrictedByCapability.js";
import { RestrictedByOrganisationPermission } from "../../auth/RestrictedByOrganisationPermission.js";

type PageSubmenuItem = PageTopbarItem;

export const DocumentsRoutes = () => {
  const { t } = useTranslate("ProjectPageTopbar");
  const viewer = useUserData().currentUser!;

  const submenuItems = React.useMemo(() => {
    const items: PageSubmenuItem[] = [
      {
        name: "documents-quotes",
        label: t("Quotes"),
        icon: <QuoteIcon />,
        path: "/documents/quotes",
        permission: "quote_document_read",
      },
      {
        name: "documents-purchase-orders",
        label: t("Purchase Orders"),
        icon: <PurchaseOrderIcon />,
        path: "/documents/purchase-orders",
        capability: "ordering",
        permission: "quote_document_update",
        isHidden: !viewer.organisation.isCraftsmanOrganisation,
      },
      {
        name: "documents-invoices",
        label: t("Invoices"),
        icon: <InvoiceIcon />,
        path: "/documents/invoices",
        permission: "invoice_document_read",
      },
    ];

    return items.filter(item => !item.isHidden);
  }, [t, viewer]);

  return (
    <Routes>
      <Route index element={<Navigate to="quotes" replace />} />
      <Route
        path={`quotes`}
        element={
          <RestrictedByOrganisationPermission permission="quote_document_read">
            <Quotes submenuItems={submenuItems} />
          </RestrictedByOrganisationPermission>
        }
      />
      <Route
        path={`invoices`}
        element={
          <RestrictedByOrganisationPermission permission="invoice_document_read">
            <Invoices submenuItems={submenuItems} />
          </RestrictedByOrganisationPermission>
        }
      />
      <Route
        path={`purchase-orders`}
        element={
          <RestrictedByCapability capability="ordering">
            <RestrictedByOrganisationPermission permission="quote_document_update">
              <PurchaseOrders submenuItems={submenuItems} />
            </RestrictedByOrganisationPermission>
          </RestrictedByCapability>
        }
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
